module.exports = __webpack_public_path__ + "img/smart_bracelet_watch.b4b6abbe.png";